// extracted by mini-css-extract-plugin
module.exports = {"bg":"#1f2732","bgDark":"#18212b","lightGrey":"#9ab5d2","accent":"#33edc0","accentDark":"#33e6b9","highlightLight":"#ffd901","highlightDark":"#077bff"};